import { render, staticRenderFns } from "./GradingList.vue?vue&type=template&id=bbb206f2"
import script from "../../controllers/grading/grading-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/grading/grading-list.js?vue&type=script&lang=js&external"
import style0 from "./GradingList.vue?vue&type=style&index=0&id=bbb206f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports